import * as aor from "react-admin";
import React from "react";
// import history from "../../common/history";

const ConfigsTitle = ({ record }) => {
    return <span>Impostazioni</span>;
};

export default ({ permissions, ...props }) => (
    <aor.List title={<ConfigsTitle />} {...props} />
);



// WEBPACK FOOTER //
// ./src/resources/Configs/List.js